<template>
  <div>
    <Navbar />

    <v-main style="padding: 64px 0px 0px 56px">
      <router-view />

      <!-- <Chartbox /> -->
    </v-main>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
// import { Auth } from "aws-amplify";
// import Chartbox from "@/components/Chatbox.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  data: () => ({
    events: [
      "mousemove",
      "mousedown",
      "scroll",
      "click",
      "load",
      "keypress",
      "mouseup",
      "dblclick",
      "mouseover",
      "mousewheel",
      "mouseout",
      "contextmenu",
    ],
    logoutTimer: null,
  }),
  components: {
    Navbar,
    // Chartbox,
  },
  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.setTimers();
    if (this.$store.getters.get_auth === false) {
      this.$router.push("/");
    }
    // Auth.currentAuthenticatedUser()
    //   .then((user) => {
    //     //  console.log("userthis.$store.getters.get_auth", user);
    //     return user;
    //   })
    //   .then((data) => console.log("data", data))
    //   .catch((err) => {
    //     console.warn("error", err);
    //     // this.$router.push("/");
    //   });
  },
  // destroyed() {
  //   this.events.forEach(function (event) {
  //     window.removeEventListener(event, this.resetTimer);
  //   }, this);
  //   this.resetTimer();
  // },
  created() {
    // this.getcountNotification();
  },
  methods: {
    setTimers() {
      this.logoutTimer = setTimeout(this.logoutUser, 420 * 1000);
    },
    logoutUser() {
      this.$router.push("/");
    },
    resetTimer() {
      clearTimeout(this.logoutTimer);
      this.setTimers();
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: this.$store.getters.get_display != 2 ? 2 : 3,
          corp_id:
            this.$store.getters.get_corpid == null
              ? 0
              : this.$store.getters.get_corpid,
          logged_user_id:
            this.$store.getters.get_display != 2
              ? this.$store.getters.get_userid
              : this.$store.getters.get_getRefDetails.user_id,
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.data != null) {
        for (let i = 0; i < responseData.data.data.length; i++) {
          switch (responseData.data.data[i].module_code) {
            case "CARDFUNDS":
              this.corpcount = responseData.data.data[i].count;
              this.$store.commit("SET_FundCount", this.corpcount);
              break;
            case "EXMGMT1":
              this.expensecount1 = responseData.data.data[i].count;
              this.$store.commit("SET_ExpenseCount1", this.expensecount1);
              break;
            case "EXMGMT2":
              this.expensecount2 = responseData.data.data[i].count;
              this.$store.commit("SET_ExpenseCount2", this.expensecount2);
              break;
            case "EXRVRY":
              this.expenserecover = responseData.data.data[i].count;
              this.$store.commit(
                "SET_ExpenseRecoverCount",
                this.expenserecover
              );
              break;
          }
        }
      }
    },
  },
};
</script>

<style></style>
